import { Modal } from '@/components/Elements';
import Button from '@/components/Button';
import { useTableOperation } from '@/features/explore/api/tableOperation';
import useExploreStore from '@/features/explore/store/useExploreStore';
import useReportsStore from '@/features/reports/store/useExploreStore';
import useEntityStore from '@/features/entity/store/useEntityStore';
import { useShallow } from 'zustand/react/shallow';
import { useTableOperation as useReportsTableOperation } from '@/features/reports/api/tableOperation';

export default function TableOpsDeleteColumn({
  tableOps,
  columnName,
  isOpen,
  onClose,
}) {
  const { setExploreFocusMode, setUpdateFocusedMessage, searchMetricCreating } =
    useExploreStore(
      useShallow((state) => ({
        setUpdateFocusedMessage: state.setUpdateFocusedMessage,
        setExploreFocusMode: state.setChartsFocusMode,
        searchMetricCreating: state.searchMetric.metricCreating,
      }))
    );

  const agentOperation =
    location.pathname.includes('explore') || searchMetricCreating
      ? useReportsTableOperation({
          config: { enabled: false },
        })
      : useTableOperation({
          config: { enabled: false },
        });

  const { resetRightPanelState } = useReportsStore(
    useShallow((state) => ({
      resetRightPanelState: state.resetRightPanelState,
    }))
  );

  const { entityOpen, setEntityOpen, resetToDefaults } = useEntityStore(
    useShallow((state) => ({
      entityOpen: state.entityOpen,
      setEntityOpen: state.setEntityOpen,
      resetToDefaults: state.resetToDefaults,
    }))
  );

  async function removeColumn() {
    if (location.pathname.includes('deep-dive')) {
      setUpdateFocusedMessage(false);
    }
    agentOperation.mutateAsync({
      ...tableOps.current,
      operation: [{ name: 'delete', field: columnName }],
    });
    if (entityOpen) {
      setEntityOpen(false);
      if (location.pathname.includes('explore')) {
        resetRightPanelState();
      } else {
        setExploreFocusMode(false);
      }
      resetToDefaults();
    }
    onClose();
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerClassName="px-0 py-0"
      className="relative"
      closeClassName="right-3 top-4"
      transition={true}
      title="Delete Column"
      topBorderClassname="border-t-4 border-pv-warning-warning-text"
      titleClassName="py-4 pl-3 font-bold text-base text-brand-ai-1100"
      topStripClassName="hidden"
      styles={{
        modal: {
          width: '460px',
        },
      }}
      showBlackDrop={false}
      isMUIModal={true}
    >
      <div className="px-3 pb-4 grid gap-2.5 text-brand-ai-1100 text-left">
        <p className="text-xs font-normal">This action cannot be undone.</p>
        <p className="text-sm font-medium">
          Are you sure you want to delete the column?
        </p>
      </div>
      <div className="flex justify-between items-center border-t border-brand-ai-300 py-4 px-3">
        <Button
          variant="ghost"
          size="medium"
          className={{ button: { root: 'font-normal' } }}
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          size="medium"
          className={{ button: { root: 'font-normal' } }}
          onClick={removeColumn}
        >
          Delete
        </Button>
      </div>
    </Modal>
  );
}
